// extracted by mini-css-extract-plugin
export default {"headsUp":"b2IKLP","header":"c2IKLP","wrapperContent":"d2IKLP","footer":"e2IKLP","addPaddingToFooter":"f2IKLP","banner":"g2IKLP","outdatedBrowserBanner":"h2IKLP"};